import axiosInstance from "./axios"; // assuming you have Axios instance setup

export const fetchComments = async (submissionId) => {
  const res = await axiosInstance.get(`/comments?submissionId=${submissionId}`);
  return res.data.data || [];
};

export const addComment = async (submissionId, senderId, content) => {
  return await axiosInstance.post(`/comments`, null, {
    params: { submissionId, senderId, content },
  });
};

export const deleteComment = async (commentId) => {
  return await axiosInstance.delete(`/comments/${commentId}`);
};
